import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Save } from 'lucide-react';

export function AdminHallsTab({ halls, onUpdateHall, saving }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-heading text-2xl">Gestione Sale</CardTitle>
        <p className="text-sm text-muted-foreground">Modifica le immagini delle sale</p>
      </CardHeader>
      <CardContent className="space-y-8">
        {halls.map((hall) => (
          <div key={hall.id} className="space-y-4 pb-8 border-b last:border-b-0">
            <h3 className="font-semibold text-lg">{hall.name}</h3>
            <p className="text-sm text-muted-foreground">{hall.description}</p>
            <div className="space-y-2">
              <Label>Immagine Attuale</Label>
              <div className="relative w-full h-48 rounded-lg overflow-hidden border">
                <img src={hall.image_url} alt={hall.name} className="w-full h-full object-cover"
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=800'; }} />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor={`image_${hall.id}`}>Nuovo URL Immagine</Label>
              <div className="flex gap-2">
                <Input id={`image_${hall.id}`} type="url" placeholder="https://esempio.com/immagine.jpg" defaultValue={hall.image_url} data-testid={`hall-image-${hall.id}`} />
                <Button onClick={() => { const input = document.getElementById(`image_${hall.id}`); if (input?.value) onUpdateHall(hall.id, input.value); }} disabled={saving} data-testid={`save-image-${hall.id}`}>
                  <Save className="w-4 h-4 mr-2" />{saving ? '...' : 'Salva'}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
